export const toAtlasCountryCode = (countryCode: string) => {
  if (countryCode.toLowerCase() === 'gb') {
    return 'uk';
  }
  return countryCode;
};
